import { EGobeletType } from '@/littleWedding/EGobeletType';
import { useConfigStore } from '@/store/config.store';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

function useProductHas3d() {
    const { productType } = storeToRefs(useConfigStore());

    const productHas3DModel = computed(() => {
        // TODO: Change this to get a boolean based on if Model is coming from back or not
        // for now 3D is only for gobelet
        // will probably change if we want to support
        // and make available 3D for other product on demand
        return productType.value === EGobeletType.SMALL || productType.value === EGobeletType.BIG;
    });

    return {
        productHas3DModel,
    };
}

export { useProductHas3d };
